import { motion } from "framer-motion";
import { PenTool, Printer, MapPin } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    num: "01",
    icon: PenTool,
    title: "We Design & Proof",
    body: "Send your artwork or work with our merch design team. You approve every proof before a single unit is printed — your vision, production-ready.",
  },
  {
    num: "02",
    icon: Printer,
    title: "Local On-Demand Print",
    body: "Your order routes to the closest print-on-demand partner in your destination region. Printed where you play, not where you flew from.",
  },
  {
    num: "03",
    icon: MapPin,
    title: "Direct Venue Delivery",
    body: "Merch lands at the venue green room, your hotel, or your door — before soundcheck. Zero cargo holds, zero customs queues, zero lost luggage.",
  },
];

export default function Manifesto() {
  return (
    <section id="process" data-testid="manifesto-process-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="mb-16 max-w-2xl"
      >
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">The process</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tighter sm:text-4xl lg:text-5xl">
          One hub. <span className="font-serif italic font-medium">Three moves.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-px border border-zinc-200 bg-zinc-200 md:grid-cols-3">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
            className="group relative bg-white p-8 transition-colors hover:bg-tour-void sm:p-10"
          >
            <div className="flex items-start justify-between">
              <span className="border-l-2 border-tour-red pl-4 font-mono text-6xl font-medium text-zinc-200 transition-colors group-hover:text-zinc-700 sm:text-7xl">
                {c.num}
              </span>
              <c.icon className="h-6 w-6 text-zinc-400 transition-colors group-hover:text-tour-red" />
            </div>
            <h3 className="mt-10 font-display text-xl font-bold tracking-tight transition-colors group-hover:text-white">
              {c.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-zinc-600 transition-colors group-hover:text-zinc-300">
              {c.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
